var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0005 14C8.68674 14 6.00045 11.3137 6.00045 8C6.00045 4.68629 8.68674 2 12.0005 2C15.3142 2 18.0005 4.68629 18.0005 8C18.0005 11.3137 15.3142 14 12.0005 14ZM12.0005 12C14.2096 12 16.0005 10.2091 16.0005 8C16.0005 5.79086 14.2096 4 12.0005 4C9.79131 4 8.00045 5.79086 8.00045 8C8.00045 10.2091 9.79131 12 12.0005 12ZM3.00045 17C4.91657 15.4671 8.00045 14 12.0005 14C16.0005 14 19.0005 15.5 21.0005 17C21.6091 18.2172 21.9399 19.7122 21.9929 21.4851C22.0011 21.7611 21.784 21.9915 21.508 21.9998L21.4931 22L2.50778 22C2.23165 22 2.00781 21.7761 2.00781 21.5L2.00804 21.4851C2.06104 19.7122 2.39184 18.2172 3.00045 17ZM4.61236 18.2846C4.40603 18.7875 4.25002 19.3588 4.14717 20L19.8537 20C19.7526 19.3695 19.6 18.8064 19.3987 18.3096C17.3112 16.8563 14.854 16 12.0005 16C9.09647 16 6.52959 16.8839 4.61236 18.2846Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarOutlined);
export default __webpack_public_path__ + "static/media/avatar-outlined.d5a6b52cf79263a8e351766688891d3e.svg";
export { ForwardRef as ReactComponent };